import { Helmet } from 'react-helmet-async';

type SEOMetaTagProps = { title: string; description: string; keywords: string; alternateUrl: string };

const SEOMetaTag = ({ title, description, keywords, alternateUrl }: SEOMetaTagProps) => {
  const OG_IMAGE_URL = 'https://c.m.011st.com/MW/img/common/og_1200627.png';

  if (!title) return null;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} data-rh="true" />
      <meta name="keywords" content={keywords} data-rh="true" />
      <meta property="og:type" content="website" data-rh="true" />
      <meta property="og:title" content={title} data-rh="true" />
      <meta property="og:image" content={OG_IMAGE_URL} data-rh="true" />
      <meta property="og:description" content={description} data-rh="true" />
      <meta property="og:site_name" content="11STREET" data-rh="true" />
      <meta name="twitter:card" content="summary_large_image" data-rh="true" />
      <meta name="twitter:title" content={title} data-rh="true" />
      <meta name="twitter:image" content={OG_IMAGE_URL} data-rh="true" />
      <meta name="twitter:site" content="@11ST_official" data-rh="true" />
      <meta name="twitter:creator" content="@11ST_official" data-rh="true" />
      <link rel="alternate" media="only screen and (max-width: 640px)" href={alternateUrl} />
    </Helmet>
  );
};

export default SEOMetaTag;
